
import { Loader2 } from "lucide-react";
import { PlanSelector } from "../PlanSelector";
import { DialogTitle } from "@/components/ui/dialog";

interface DialogContentProps {
  isPlansLoading: boolean;
  updateComplete: boolean;
  isRedirecting: boolean;
  isDowngradeLoading: boolean;
  downgradeSuccess: boolean;
  downgradeMessage: string | null;
  selectedPlan: string;
  handlePlanSelection: (plan: string) => void;
  handleConfirmPlan: () => void;
  handleOpenBillingPortal: () => void;
  handleDowngrade: (currentPlan: string, newPlan: string) => Promise<{ success: boolean; data?: any; error?: any }>;
  isLoading: boolean;
  isPortalLoading: boolean;
  hasConfigs: boolean;
  planConfigs?: any; // Add this prop to match PlanSelector
  isAnnual: boolean;
  setIsAnnual: (value: boolean) => void;
  pendingDowngrade: boolean;
  nextPlan?: string;
  downgradeDate: string | null;
}

export const DialogContent = ({
  isPlansLoading,
  updateComplete,
  isRedirecting,
  isDowngradeLoading,
  downgradeSuccess,
  downgradeMessage,
  selectedPlan,
  handlePlanSelection,
  handleConfirmPlan,
  handleOpenBillingPortal,
  handleDowngrade,
  isLoading,
  isPortalLoading,
  hasConfigs,
  planConfigs, // Include this in props
  isAnnual,
  setIsAnnual,
  pendingDowngrade,
  nextPlan,
  downgradeDate
}: DialogContentProps) => {
  if (isPlansLoading) {
    return (
      <div className="flex flex-col items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-gray-500 mb-4" />
        <p className="text-gray-600">Loading subscription plans...</p>
      </div>
    );
  }

  if (updateComplete || isRedirecting || isDowngradeLoading || downgradeSuccess) {
    return (
      <div className="flex flex-col items-center justify-center py-12">
        <Loader2 className={`h-8 w-8 animate-spin ${downgradeSuccess ? "text-green-500" : "text-blue-500"} mb-4`} />
        <p className={downgradeSuccess ? "text-green-600" : "text-blue-600"}>
          {downgradeSuccess ? downgradeMessage : 
           isDowngradeLoading ? "Processing downgrade..." :
           isRedirecting ? "Opening portal..." : 
           "Redirecting to payment page..."}
        </p>
      </div>
    );
  }

  return (
    <>
      <DialogTitle className="sr-only">Subscription Plans</DialogTitle>
      <PlanSelector
        selectedPlan={selectedPlan}
        onSelectPlan={handlePlanSelection}
        onPlanSelect={handlePlanSelection} 
        onConfirmDowngrade={handleDowngrade}
        isLoading={isLoading || isPortalLoading}
        onManageSubscription={handleOpenBillingPortal}
        planConfigs={planConfigs || []} 
        isAnnual={isAnnual}
        setIsAnnual={setIsAnnual}
        pendingDowngrade={pendingDowngrade}
        nextPlan={nextPlan}
        downgradeDate={downgradeDate}
        // Add missing props
        onCancelDowngrade={() => {}}
        controlsText=""
        subtitle=""
      />
    </>
  );
};
